import Axios from "../../../axios.js";
import {bellMusicApiConstants} from "../../../constants/ApiConstant";


export async function saveBellMusic(params) {
    return Axios.post(bellMusicApiConstants.SAVE_BELL_MUSIC, params);
}

export async function searchBellMusic(params, page, size) {
    return Axios.post(bellMusicApiConstants.SEARCH_BELL_MUSIC + `?page=${page}&size=${size}`, params);
}

export async function deleteNotice(params) {
    return Axios.post(bellMusicApiConstants.DELETE_BELL_MUSIC, params);
}
